import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./SideMenuStyle.css";
import LogoutPopUp from "../popup/LogoutPopUp"

const SideMenu = ({isMenu, setIsMenu}) => {
  
  const [logoutToggler, setLogoutToggler] = useState(false);

  const navigate = useNavigate();
  const name = localStorage.getItem("firstName");
  const profileImg = localStorage.getItem("profileImg");
  const pathname = window.location.pathname;

  return (
    <>
    <LogoutPopUp isActive={logoutToggler} setIsActive={setLogoutToggler}/>
    <div className={`menuOuter ${!isMenu ? '' : 'active'}`}>
      <div className="adminProfile">
        <img
          src={
            profileImg === "null"
              ? "/assets/img/profiledefault.png"
              : profileImg
          }
          alt=""
          className="adminImg"
        />
        <div className="adminProfileContent">
          <p className="name">{name}</p>
          <p
            className="greyText"
            onClick={() => {
              navigate(`/profile`);
            }}
          >
            View Profile
          </p>
        </div>
      </div>
      <div className="menuFlex">
        <div className="menuList">
          <div
            className={`menuListItem ${pathname === "/" && "active"}`}
            onClick={() => {
              navigate(`/`);
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.45 22.75C16.32 22.75 15.13 22.48 13.9 21.96C12.7 21.45 11.49 20.75 10.31 19.9C9.14 19.04 8.01 18.08 6.94 17.03C5.88 15.96 4.92 14.83 4.07 13.67C3.21 12.47 2.52 11.27 2.03 10.11C1.51 8.87 1.25 7.67 1.25 6.54C1.25 5.76 1.39 5.02 1.66 4.33C1.94 3.62 2.39 2.96 3 2.39C3.77 1.63 4.65 1.25 5.59 1.25C5.98 1.25 6.38 1.34 6.72 1.5C7.11 1.68 7.44 1.95 7.68 2.31L10 5.58C10.21 5.87 10.37 6.15 10.48 6.43C10.61 6.73 10.68 7.03 10.68 7.32C10.68 7.7 10.57 8.07 10.36 8.42C10.21 8.69 9.98 8.98 9.69 9.27L9.01 9.98C9.02 10.01 9.03 10.03 9.04 10.05C9.16 10.26 9.4 10.62 9.86 11.16C10.35 11.72 10.81 12.23 11.27 12.7C11.86 13.28 12.35 13.74 12.81 14.12C13.38 14.6 13.75 14.84 13.97 14.95L13.95 15L14.68 14.28C14.99 13.97 15.29 13.74 15.58 13.59C16.13 13.25 16.83 13.19 17.53 13.48C17.79 13.59 18.07 13.74 18.37 13.95L21.69 16.31C22.06 16.56 22.33 16.88 22.49 17.26C22.64 17.64 22.71 17.99 22.71 18.34C22.71 18.82 22.6 19.3 22.39 19.75C22.18 20.2 21.92 20.59 21.59 20.95C21.02 21.58 20.4 22.03 19.68 22.32C18.99 22.6 18.24 22.75 17.45 22.75ZM5.59 2.75C5.04 2.75 4.53 2.99 4.04 3.47C3.58 3.9 3.26 4.37 3.06 4.88C2.85 5.4 2.75 5.95 2.75 6.54C2.75 7.47 2.97 8.48 3.41 9.52C3.86 10.58 4.49 11.68 5.29 12.78C6.09 13.88 7 14.95 8 15.96C9 16.95 10.08 17.87 11.19 18.68C12.27 19.47 13.38 20.11 14.48 20.57C16.19 21.3 17.79 21.47 19.11 20.92C19.62 20.71 20.07 20.39 20.48 19.93C20.71 19.68 20.89 19.41 21.04 19.09C21.16 18.84 21.22 18.58 21.22 18.32C21.22 18.16 21.19 18 21.11 17.82C21.08 17.76 21.02 17.65 20.83 17.52L17.51 15.16C17.31 15.02 17.13 14.92 16.96 14.85C16.74 14.76 16.65 14.67 16.31 14.88C16.11 14.98 15.93 15.13 15.73 15.33L14.97 16.08C14.58 16.46 13.98 16.55 13.52 16.38L13.25 16.26C12.84 16.04 12.36 15.7 11.83 15.25C11.35 14.84 10.83 14.36 10.2 13.74C9.71 13.24 9.22 12.71 8.71 12.12C8.24 11.57 7.9 11.1 7.69 10.71L7.57 10.41C7.51 10.18 7.49 10.05 7.49 9.91C7.49 9.55 7.62 9.23 7.87 8.98L8.62 8.2C8.82 8 8.97 7.81 9.07 7.64C9.15 7.51 9.18 7.4 9.18 7.3C9.18 7.22 9.15 7.1 9.1 6.98C9.03 6.82 8.92 6.64 8.78 6.45L6.46 3.17C6.36 3.03 6.24 2.93 6.09 2.86C5.93 2.79 5.76 2.75 5.59 2.75ZM13.95 15.01L13.79 15.69L14.06 14.99C14.01 14.98 13.97 14.99 13.95 15.01Z"
                fill="#737373"
              />
              <path
                d="M18.5 9.75C18.09 9.75 17.75 9.41 17.75 9C17.75 8.64 17.39 7.89 16.79 7.25C16.2 6.62 15.55 6.25 15 6.25C14.59 6.25 14.25 5.91 14.25 5.5C14.25 5.09 14.59 4.75 15 4.75C15.97 4.75 16.99 5.27 17.88 6.22C18.71 7.11 19.25 8.2 19.25 9C19.25 9.41 18.91 9.75 18.5 9.75Z"
                fill="#737373"
              />
              <path
                d="M22 9.75C21.59 9.75 21.25 9.41 21.25 9C21.25 5.55 18.45 2.75 15 2.75C14.59 2.75 14.25 2.41 14.25 2C14.25 1.59 14.59 1.25 15 1.25C19.27 1.25 22.75 4.73 22.75 9C22.75 9.41 22.41 9.75 22 9.75Z"
                fill="#737373"
              />
            </svg>
            Call History
          </div>
          <div
            className={`menuListItem ${(pathname === "/feedback" || pathname.split("/")[1] === "viewFeedback") && "active"}`}
            onClick={() => {
              navigate(`/feedback`);
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.0977 2.18352C10.35 1.61585 10.9129 1.25 11.5342 1.25C13.3102 1.25 14.75 2.68978 14.75 4.46584V8C14.75 8.13807 14.8619 8.25 15 8.25H18.5032C20.8015 8.25 22.559 10.2986 22.2096 12.5702L21.1326 19.5702C20.8512 21.3996 19.2771 22.75 17.4262 22.75H4C2.48122 22.75 1.25 21.5188 1.25 20V13C1.25 11.4812 2.48122 10.25 4 10.25H6.35013C6.44892 10.25 6.53845 10.1918 6.57858 10.1015L10.0977 2.18352ZM7.75 21.25H17.4262C18.5368 21.25 19.4812 20.4398 19.6501 19.3421L20.727 12.3421C20.9367 10.9792 19.8822 9.75 18.5032 9.75H15C14.0335 9.75 13.25 8.9665 13.25 8V4.46584C13.25 3.51821 12.4818 2.75 11.5342 2.75C11.5057 2.75 11.48 2.76674 11.4684 2.79273L7.9493 10.7107C7.89508 10.8327 7.82797 10.9464 7.75 11.0503V21.25ZM6.25 11.75V21.25H4C3.30964 21.25 2.75 20.6904 2.75 20V13C2.75 12.3096 3.30964 11.75 4 11.75H6.25Z"
                fill="#737373"
              />
            </svg>
            Feedback
          </div>

          <div className="menuListItem logoutToggler"  onClick={() =>setLogoutToggler(true)}>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.1001 16.44C14.7901 20.04 12.9401 21.51 8.8901 21.51L8.7601 21.51C4.2901 21.51 2.5001 19.72 2.5001 15.25L2.5001 8.73001C2.5001 4.26001 4.2901 2.47001 8.7601 2.47001L8.8901 2.47001C12.9101 2.47001 14.7601 3.92001 15.0901 7.46001"
                stroke="#404040"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.99988 12L20.3799 12"
                stroke="#404040"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M18.15 15.35L21.5 12L18.15 8.64997"
                stroke="#404040"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Logout
          </div>

        </div>
      </div>
    </div>
    </>
  );
};

export default SideMenu;
